import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/activity.vue'
createPage(Page)